const riot = require('riot');

riot.tag2('cell-distribution_rule_status-badge', '<atom-distribution_rule_status-badge item="{opts.item}"></atom-distribution_rule_status-badge>', 'cell-distribution_rule_status-badge,[data-is="cell-distribution_rule_status-badge"]{display:flex;align-items:center;justify-content:center}', '', function(opts) {
});